"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateListingDtoAllowPrivateInspectionsEnum = exports.UpdateListingDtoOffersAllowedEnum = exports.UpdateListingDtoPropertyVisibilityEnum = exports.UpdateListingDtoListingStatusEnum = exports.UpdateListingDtoSaleTypeEnum = exports.UpdateListingDtoCampaignEnum = void 0;
exports.instanceOfUpdateListingDto = instanceOfUpdateListingDto;
exports.UpdateListingDtoFromJSON = UpdateListingDtoFromJSON;
exports.UpdateListingDtoFromJSONTyped = UpdateListingDtoFromJSONTyped;
exports.UpdateListingDtoToJSON = UpdateListingDtoToJSON;
exports.UpdateListingDtoToJSONTyped = UpdateListingDtoToJSONTyped;
var DocumentVisibility_1 = require("./DocumentVisibility");
/**
 * @export
 */
exports.UpdateListingDtoCampaignEnum = {
    VendorManaged: 'vendor_managed',
    UnreservedManaged: 'unreserved_managed'
};
/**
 * @export
 */
exports.UpdateListingDtoSaleTypeEnum = {
    PrivateSale: 'private_sale',
    Auction: 'auction',
    ReverseAuction: 'reverse_auction'
};
/**
 * @export
 */
exports.UpdateListingDtoListingStatusEnum = {
    Draft: 'draft',
    Active: 'active',
    UnderOffer: 'under_offer',
    OffTheMarket: 'off_the_market',
    PassedIn: 'passed_in',
    Disabled: 'disabled',
    Deleted: 'deleted',
    Sold: 'sold'
};
/**
 * @export
 */
exports.UpdateListingDtoPropertyVisibilityEnum = {
    Hide: 'hide',
    Unhide: 'unhide'
};
/**
 * @export
 */
exports.UpdateListingDtoOffersAllowedEnum = {
    Yes: 'yes',
    No: 'no'
};
/**
 * @export
 */
exports.UpdateListingDtoAllowPrivateInspectionsEnum = {
    Yes: 'yes',
    No: 'no'
};
/**
 * Check if a given object implements the UpdateListingDto interface.
 */
function instanceOfUpdateListingDto(value) {
    return true;
}
function UpdateListingDtoFromJSON(json) {
    return UpdateListingDtoFromJSONTyped(json, false);
}
function UpdateListingDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'campaign': json['campaign'] == null ? undefined : json['campaign'],
        'defaultTemplateId': json['defaultTemplateId'] == null ? undefined : json['defaultTemplateId'],
        'saleType': json['saleType'] == null ? undefined : json['saleType'],
        'price': json['price'] == null ? undefined : json['price'],
        'displayPrice': json['displayPrice'] == null ? undefined : json['displayPrice'],
        'reservePrice': json['reservePrice'] == null ? undefined : json['reservePrice'],
        'listingStatus': json['listingStatus'] == null ? undefined : json['listingStatus'],
        'intervalSpanInMinutes': json['intervalSpanInMinutes'] == null ? undefined : json['intervalSpanInMinutes'],
        'bidIncrement': json['bidIncrement'] == null ? undefined : json['bidIncrement'],
        'reverseAuctionDecreaseAmount': json['reverseAuctionDecreaseAmount'] == null ? undefined : json['reverseAuctionDecreaseAmount'],
        'auctionStartDate': json['auctionStartDate'] == null ? undefined : json['auctionStartDate'],
        'propertyVisibility': json['propertyVisibility'] == null ? undefined : json['propertyVisibility'],
        'documentVisibilities': json['documentVisibilities'] == null ? undefined : (json['documentVisibilities'].map(DocumentVisibility_1.DocumentVisibilityFromJSON)),
        'offersAllowed': json['offersAllowed'] == null ? undefined : json['offersAllowed'],
        'auctionStartPrice': json['auctionStartPrice'] == null ? undefined : json['auctionStartPrice'],
        'allowPrivateInspections': json['allowPrivateInspections'] == null ? undefined : json['allowPrivateInspections'],
        'enableAutoReply': json['enableAutoReply'] == null ? undefined : json['enableAutoReply'],
        'skipContractReview': json['skipContractReview'] == null ? undefined : json['skipContractReview'],
    };
}
function UpdateListingDtoToJSON(json) {
    return UpdateListingDtoToJSONTyped(json, false);
}
function UpdateListingDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'campaign': value['campaign'],
        'defaultTemplateId': value['defaultTemplateId'],
        'saleType': value['saleType'],
        'price': value['price'],
        'displayPrice': value['displayPrice'],
        'reservePrice': value['reservePrice'],
        'listingStatus': value['listingStatus'],
        'intervalSpanInMinutes': value['intervalSpanInMinutes'],
        'bidIncrement': value['bidIncrement'],
        'reverseAuctionDecreaseAmount': value['reverseAuctionDecreaseAmount'],
        'auctionStartDate': value['auctionStartDate'],
        'propertyVisibility': value['propertyVisibility'],
        'documentVisibilities': value['documentVisibilities'] == null ? undefined : (value['documentVisibilities'].map(DocumentVisibility_1.DocumentVisibilityToJSON)),
        'offersAllowed': value['offersAllowed'],
        'auctionStartPrice': value['auctionStartPrice'],
        'allowPrivateInspections': value['allowPrivateInspections'],
        'enableAutoReply': value['enableAutoReply'],
        'skipContractReview': value['skipContractReview'],
    };
}
